import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';

import Button from 'components/common/Button';

const styles = () => ({
  root: {
    marginTop: 95,
    marginBottom: 24,
  },
  button: {
    '& + $button': {
      marginLeft: 24,
    },
  },
});

const OrderDetailsToolbar = ({
  variant,
  onSubmitButtonClick,
  onCancelButtonClick,
  submitButtonDisabled,
  classes,
}) => (
  <Toolbar
    className={classes.root}
    disableGutters
  >
    <Grid
      container
      justify="flex-end"
      alignItems="center"
      spacing={24}
      wrap="nowrap"
    >
      <Grid item>
        <Button
          variant="raised"
          className={classes.button}
          {...onCancelButtonClick ? { onClick: onCancelButtonClick } : {}}
        >
          Close
        </Button>
        <Button
          variant="raised"
          color="primary"
          className={classes.button}
          {...onSubmitButtonClick ? { onClick: onSubmitButtonClick } : {}}
          disabled={submitButtonDisabled}
        >
          {variant === 'create' && 'Done'}
          {variant === 'edit' && 'Save'}
          {variant === 'view' && 'Print'}
          {variant === 'copy' && 'Done'}
        </Button>
      </Grid>
    </Grid>
  </Toolbar>
);

OrderDetailsToolbar.propTypes = {
  onSubmitButtonClick: PropTypes.func,
  onCancelButtonClick: PropTypes.func,
  submitButtonDisabled: PropTypes.bool,
  variant: PropTypes.oneOf(['create', 'edit', 'view', 'copy']),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

OrderDetailsToolbar.defaultProps = {
  onSubmitButtonClick: null,
  onCancelButtonClick: null,
  submitButtonDisabled: false,
  variant: 'create',
};

export default withStyles(styles)(OrderDetailsToolbar);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderDetailsToolbar/OrderDetailsToolbar.js